import {
  PATH_ABOUT,
  PATH_CONTACT,
  PATH_PORTFOLIO,
  PATH_SERVICE,
  PATH_SERVICE_DETAIL,
  PATH_TECHNOLOGY,
} from "./constants";
import Images from "./imagePaths";
import {
  CompanyInfoItemType,
  FooterColItemType,
  FooterCompmayInfoItemType,
  OurCoreValuesItemType,
  PortfolioItemType,
  PortfolioSectionType,
  ServiceDetailPageItemType,
  ServicesItemTypes,
  SocialMediaItemType,
  TechAdvantageSectionType,
  TechnologyPageItemType,
  TechnologyTabsTypes,
  TechnologyWeUseSectionType,
} from "./types/generaTypes";

export const SERVICES: ServicesItemTypes[] = [
  {
    to: `${PATH_SERVICE_DETAIL}/web_development`,
    icon: Images.SVG_WEB_DEVELOPMENT_ICON,
    title: "Web Development",
    description:
      "Custom websites and web applications built with modern technologies",
    serviceAdvantages: [
      "Responsive web design",
      "E-commerce solutions",
      "Content management systems",
      "Progressive web apps",
      "API development & integration",
      "Performance optimization",
    ],
  },
  {
    to: `${PATH_SERVICE_DETAIL}/mobile_app_developemnt`,
    icon: Images.SVG_MOBILE_DEVELOPMENT_ICON,
    title: "Mobile App Development",
    description:
      "Native and cross-platform mobile applications for iOS and Android",
    serviceAdvantages: [
      "iOS & Android development",
      "Cross-platform solutions",
      "App store optimization",
      "Push notifications",
      "Offline functionality",
      "App maintenance & updates",
    ],
  },
  {
    to: `${PATH_SERVICE_DETAIL}/ui_ux`,
    icon: Images.SVG_UI_UX_ICON,
    title: "UI/UX Design",
    description:
      "User-centered design solutions that enhance user experience and engagement",
    serviceAdvantages: [
      "User experience research",
      "Wireframing & prototyping",
      "Visual design systems",
      "Usability testing",
      "Accessibility design",
      "Brand identity design",
    ],
  },
  {
    to: `${PATH_SERVICE_DETAIL}/digital_marketing`,
    icon: Images.SVG_DIGITAL_MARKETING_ICON,
    title: "Digital Marketing",
    description:
      "Strategic online marketing to grow your business and reach your audience",
    serviceAdvantages: [
      "Search engine optimization",
      "Social media marketing",
      "Content marketing strategy",
      "Pay-per-click advertising",
      "Email marketing campaigns",
      "Analytics & reporting",
    ],
  },
];

export const COMPANY: FooterColItemType = {
  title: "Company",
  data: [
    { label: "Home", to: "/" },
    { label: "Services", to: PATH_SERVICE },
    { label: "About", to: PATH_ABOUT },
    { label: "Contact", to: PATH_CONTACT },
    { label: "Portfolio", to: PATH_PORTFOLIO },
  ],
};
export const SERVICES_FOOTER: FooterColItemType = {
  title: "Services",
  data: [
    {
      label: "Web Development",
      to: `${PATH_SERVICE_DETAIL}/web_development`,
    },
    {
      label: "Application Development",
      to: `${PATH_SERVICE_DETAIL}/mobile_app_developemnt`,
    },
    {
      label: "UI/UX Design",
      to: `${PATH_SERVICE_DETAIL}/ui_ux`,
    },
    {
      label: "Digital Marketing",
      to: `${PATH_SERVICE_DETAIL}/digital_marketing`,
    },
  ],
};
export const TECHNOLOGIES: FooterColItemType = {
  title: "Technologies",
  data: [
    {
      label: "React Native",
      to: `${PATH_TECHNOLOGY}/reactNative`,
    },
    { label: "React Js", to: `${PATH_TECHNOLOGY}/react` },
    { label: "Node Js", to: `${PATH_TECHNOLOGY}/node` },
    { label: "MongoDB", to: `${PATH_TECHNOLOGY}/mongodb` },
    { label: "GraphQL", to: `${PATH_TECHNOLOGY}/graphql` },
    {
      label: "PostGreSql",
      to: `${PATH_TECHNOLOGY}/postgresql`,
    },
  ],
};
export const SOCIAL_MEDIA: SocialMediaItemType[] = [
  {
    icon: Images.SVG_INSTAGRAM_BLACK_ICON,
    hoverIcon: Images.SVG_INSTAGRAM_WHITE_ICON,
    title: "instaram",
    to: "",
  },
  {
    icon: Images.SVG_FACEBOOK_BLACK_ICON,
    hoverIcon: Images.SVG_FACEBOOK_WHITE_ICON,
    title: "facebook",
    to: "",
  },
  {
    icon: Images.SVG_LINKEDLIN_BLACK_ICON,
    hoverIcon: Images.SVG_LINKEDLIN_WHITE_ICON,
    title: "linkedlin",
    to: "",
  },
  {
    icon: Images.SVG_TWITTER_BLACK_ICON,
    hoverIcon: Images.SVG_TWITTER_WHITE_ICON,
    title: "twitter",
    to: "",
  },
];
export const COMPANY_INFO: CompanyInfoItemType[] = [
  {
    icon: Images.SVG_EMAIL_WHITE_ICON,
    title: "Email Us",
    value: "contact@jdsofttech.in",
    desc: "Send us an email anytime",
  },
  {
    icon: Images.SVG_CALL_WHITE_ICON,
    title: "Call Us",
    value: "+91 9664009145",
    desc: "Mon-Fri from 10am to 7pm",
  },
  {
    icon: Images.SVG_LOCATION_WHITE_ICON,
    title: "Visit Us",
    value:
      "RIICO, Near Signature Bar & Restaurent, Bhilwara City, Rajasthan, India, 311001",
    desc: "Come say hello at our office",
  },
  // {
  //   icon: Images.SVG_CLOCK_WHITE_ICON,
  //   title: "Working Hours",
  //   value: "Mon - Sat : 10:00 AM - 7:00 PM",
  //   desc: "Weekend consultations available",
  // },
];
export const WHY_CHOOSE_US = [
  "Free initial consultation and project assessment",
  "Transparent pricing with no hidden costs",
  "24/7 support and maintenance packages",
  "Agile development process with regular updates",
  "100% satisfaction guarantee",
];

export const FOOTER_COMPANY_INFO: FooterCompmayInfoItemType[] = [
  {
    icon: Images.SVG_EMAIL_ICON,
    label: "contact@jdsofttech.in",
    title: "Email",
  },
  {
    icon: Images.SVG_CALL_ICON,
    label: "+91 9664009145",
    title: "Mobile Number",
  },
  {
    icon: Images.SVG_LOCATION_ICON,
    label: "Bhilwara, Rajasthan, India",
    title: "location",
  },
];

export const OUR_CORE_VALUES: OurCoreValuesItemType[] = [
  {
    title: "Results-Driven",
    desc: "We focus on delivering measurable outcomes that drive your business forward and exceed expectations.",
    icon: Images.SVG_RESULT_WHITE_ICON,
  },
  {
    title: "Collaborative Approach",
    desc: "We work closely with our clients as partners, ensuring transparent communication throughout the project.",
    icon: Images.SVG_USERS_WHITE_ICON,
  },
  {
    title: "Quality Excellence",
    desc: "We maintain the highest standards in code quality, design, and user experience in every project we deliver.",
    icon: Images.SVG_BADGE_WHITE_ICON,
  },
  {
    title: "Timely Delivery",
    desc: "We respect deadlines and deliver projects on time without compromising on quality or functionality.",
    icon: Images.SVG_CLOCK_WHITE_ICON,
  },
];

export const PORTFOLIO: PortfolioItemType[] = [
  {
    img: Images.SVG_FANTASY_GAMMING_ICON,
    title: "Fantasy Gaming",
    desc: "High-performance platforms with real-time data, secure payments, and immersive gameplay.",
    data: [
      "Live score integration",
      "Secure payment systems",
      "Leaderboard & rewards",
      "Multi-device support",
    ],
  },
  {
    img: Images.SVG_LMS_ICON,
    title: "LMS",
    desc: "Interactive learning platforms with live classes, analytics, and seamless course delivery.",
    data: [
      "Live & recorded lectures",
      "Test & quiz portals",
      "Progress tracking",
      "Student–teacher chat",
    ],
  },
  {
    img: Images.SVG_HEALTH_AND_FITNESS_ICON,
    title: "Health & Fitness",
    desc: "Digital solutions for fitness tracking, telemedicine, and healthy lifestyle engagement.",
    data: [
      "Workout & diet tracking",
      "Telemedicine integration",
      "Wearable device sync",
      "Progress reports",
    ],
  },
  {
    img: Images.SVG_E_COMMERCE_ICON,
    title: "E-Commerce",
    desc: "Scalable online stores with secure checkout, smooth UX, and robust product management.",
    data: [
      "Custom storefronts",
      "SEO optimization",
      "Content management",
      "Analytics integration",
    ],
  },
  {
    img: Images.SVG_PUBLIC_SERVICES_ICON,
    title: "Public Services",
    desc: "Citizen-focused apps enabling communication, updates, and engagement with authorities.",
    data: [
      "Real-time notifications",
      "Complaint tracking",
      "Community forums",
      "Service requests",
    ],
  },
  {
    img: Images.SVG_SOCIAL_MEDIA_ICON,
    title: "Social Media",
    desc: "Platforms with advanced chat, feeds, and media sharing for stronger digital communities.",
    data: [
      "Instant messaging",
      "Custom news feeds",
      "Push notifications",
      "Media sharing",
    ],
  },
  {
    img: Images.SVG_RENTAL_PROPERTY_ICON,
    title: "Rental Property",
    desc: "Smart rental apps for properties, vehicles, and equipment with seamless transactions.",
    data: [
      "Easy booking system",
      "Secure payments",
      "Listing management",
      "Automated invoices",
    ],
  },
];
export const PORTFOLIO_SECTION: PortfolioSectionType = {
  sectionHeading: "💼 Our Portfolio",
  headingPart1: "Projects That",
  headingPart2: "Make Impact",
  description:
    "Discover how we've helped businesses across various industries achieve their digital transformation goals.",
  portfolio: PORTFOLIO,
};

export const TECHNOLOGY_PAGE: TechnologyPageItemType = {
  reactNative: {
    homeSection: {
      sectionHeader: "📱 Mobile Framework",
      title: "React Native",
      img: Images.SVG_REACT_NATIVE_ICON,
      description:
        "Create native mobile apps for iOS and Android using React. Build cross-platform applications with truly native performance and user experience.",
      achievements: [
        {
          label: "Apps Built",
          count: "50M+",
        },
        {
          label: "GitHub Stars",
          count: "110k+",
        },
        {
          label: "Years Proven",
          count: "8+",
        },
        {
          label: "Created",
          count: "Meta",
        },
      ],
    },
    whychooseTech: {
      title: "Why Choose React Native?",
      description:
        "Discover the powerful features that make React Native the leading choice for cross-platform mobile development.",
      data: [
        {
          icon: Images.SVG_MOBILE_DEVELOPMENT_ICON,
          title: "Cross-Platform",
          description:
            "Write once, run everywhere. Build apps for iOS and Android using a single codebase with native performance.",
        },
        {
          icon: Images.SVG_LIGHTING_ICON,
          title: "Native Performance",
          description:
            "Bridge technology ensures your apps run with native performance, not web view limitations.",
        },
        {
          icon: Images.SVG_CODE_ICON,
          title: "React Patterns",
          description:
            "Use familiar React concepts like components, state, and props to build mobile applications",
        },
        {
          icon: Images.SVG_GLOBAL_ICON,
          title: "Hot Reloading",
          description:
            "See changes instantly with fast refresh and hot reloading during development.",
        },
      ],
    },
    techMultiplePlatform: {
      title: "One Codebase, Multiple Platforms",
      description:
        "Develop faster and more efficiently with shared business logic and UI components.",
      data: [
        {
          type: "Native Performance",
          title: "iOS",
          description:
            "Native iOS experience with platform-specific components and behaviors",
          icon: Images.SVG_MOBILE_DEVELOPMENT_ICON,
          to: "/ios",
        },
        {
          type: "Shared Logic",
          title: "React Native",
          description:
            "Single codebase powering both platforms with 90%+ code reuse",
          icon: Images.SVG_CODE_ICON,
          to: "/react-native",
        },
        {
          type: "Native Performance",
          title: "Android",
          description:
            "Native Android experience following Material Design principles",
          icon: Images.SVG_GLOBAL_ICON,
          to: "/android",
        },
      ],
    },
    techAdvantage: {
      title: "Perfect For Mobile Apps",
      description:
        "From startup mobile apps to enterprise solutions, React Native provides the performance and flexibility needed for successful mobile applications.",
      data: [
        "E-commerce Mobile Apps",
        "Social Media Platforms",
        "Food Delivery Applications",
        "Financial & Banking Apps",
        "Health & Fitness Trackers",
        "News & Media Applications",
      ],
      quickStart: [
        "# Install React Native CLI",
        "npm install -g react-native-cli",
        "# Create new project",
        "npx react-native init MyApp",
        "# Run on iOS",
        "npx react-native run-ios",
        "# Run on Android",
        "npx react-native run-android",
      ],
      viewDocPath: "https://reactnative.dev/docs/getting-started",
    },
    ecoSystem: {
      title: "React Native Ecosystem",
      description:
        "Explore the powerful tools and libraries that enhance React Native development.",
      data: [
        {
          to: "https://expo.dev",
          type: "Framework",
          title: "Expo",
          description: "Popular in React Native ecosystem",
        },
        {
          to: "https://react.dev",
          type: "Web Framework",
          title: "React.js",
          description: "Popular in React Native ecosystem",
        },
        {
          to: "https://www.typescriptlang.org",
          type: "Language",
          title: "TypeScript",
          description: "Popular in React Native ecosystem",
        },
        {
          to: "https://reactnavigation.org",
          type: "Navigation",
          title: "React Navigation",
          description: "Popular in React Native ecosystem",
        },
        {
          to: "https://redux-toolkit.js.org",
          type: "State Management",
          title: "Redux Toolkit",
          description: "Popular in React Native ecosystem",
        },
        {
          to: "https://firebase.google.com",
          type: "Backend",
          title: "Firebase",
          description: "Popular in React Native ecosystem",
        },
      ],
    },
    footer: {
      title: "Ready to Build Mobile Apps?",
      description:
        "Join thousands of developers building amazing mobile experiences with React Native's cross-platform power.",
    },
  },
  react: {
    homeSection: {
      sectionHeader: "🚀 JavaScript Library",
      title: "React.js",
      img: Images.SVG_REACT_ICON,
      description:
        "A JavaScript library for building user interfaces. Create interactive UIs with declarative, component-based architecture that makes development predictable and efficient.",
      achievements: [
        {
          label: "Downloads/Month",
          count: "200M+",
        },
        {
          label: "GitHub Stars",
          count: "2M+",
        },
        {
          label: "Years Strong",
          count: "10+",
        },
        {
          label: "Backed",
          count: "Meta",
        },
      ],
    },
    whychooseTech: {
      title: "Why Choose React.js?",
      description:
        "Discover the powerful features that make React the go-to choice for modern web development.",
      data: [
        {
          icon: Images.SVG_LIGHTING_ICON,
          title: "Lightning Fast",
          description:
            "Virtual DOM and optimized rendering for blazing-fast performance in web applications.",
        },
        {
          icon: Images.SVG_LAYER_ICON,
          title: "Component-Based",
          description:
            "Build encapsulated components that manage their own state and compose them into complex UIs.",
        },
        {
          icon: Images.SVG_GLOBAL_ICON,
          title: "Learn Once, Write Anywhere",
          description:
            "Use React for web apps, React Native for mobile, and Next.js for server-side rendering.",
        },
        {
          icon: Images.SVG_USERS_WHITE_ICON,
          title: "Massive Ecosystem",
          description:
            "Leverage thousands of libraries, tools, and resources from the vibrant React community.",
        },
      ],
    },
    techAdvantage: {
      title: "Perfect For Every Project",
      description:
        "From startup MVPs to enterprise applications, React scales with your needs and provides the flexibility to build exactly what you envision.",
      data: [
        "Single Page Applications (SPAs)",
        "Progressive Web Apps (PWAs)",
        "E-commerce Platforms",
        "Social Media Applications",
        "Dashboard & Analytics",
        "Content Management Systems",
      ],
      quickStart: [
        "# Create a new React app",
        "npx create-react-app my-app",
        "# Navigate to directory",
        "cd my-app",
        "# Start development server",
        "npm start",
      ],
      viewDocPath: "https://reactjs.org/docs/getting-started.html",
    },
    ecoSystem: {
      title: "React Ecosystem",
      description:
        "Explore the powerful tools and frameworks that complement React development.",
      data: [
        {
          to: "https://nextjs.org",
          type: "Framework",
          title: "Next.js",
          description: "Popular in React ecosystem",
        },
        {
          to: "https://reactnative.dev",
          type: "Mobile",
          title: "React Native",
          description: "Popular in React ecosystem",
        },
        {
          to: "https://redux.js.org",
          type: "State Management",
          title: "Redux",
          description: "Popular in React ecosystem",
        },
        {
          to: "https://www.typescriptlang.org",
          type: "Language",
          title: "TypeScript",
          description: "Popular in React ecosystem",
        },
        {
          to: "https://vitejs.dev",
          type: "Build Tool",
          title: "Vite",
          description: "Popular in React ecosystem",
        },
        {
          to: "https://tailwindcss.com",
          type: "Styling",
          title: "Tailwind CSS",
          description: "Popular in React ecosystem",
        },
      ],
    },
    footer: {
      title: "Ready to Build Something Amazing?",
      description:
        "Join millions of developers who trust React to build fast, scalable, and maintainable web applications.",
    },
  },
  node: {
    homeSection: {
      sectionHeader: "⚡ JavaScript Runtime",
      title: "Node.js",
      img: Images.SVG_NODE_ICON,
      description:
        "A JavaScript runtime built on Chrome's V8 JavaScript engine. Build scalable network applications with event-driven, non-blocking I/O model.",
      achievements: [
        {
          label: "Downloads/Month",
          count: "3B+",
        },
        {
          label: "GitHub Stars",
          count: "98k+",
        },
        {
          label: "Years Strong",
          count: "14+",
        },
        {
          label: "Foundation",
          count: "OpenJS",
        },
      ],
    },
    whychooseTech: {
      title: "Why Choose Node.js?",
      description:
        "Discover the powerful features that make Node.js the go-to choice for server-side development.",
      data: [
        {
          icon: Images.SVG_LIGHTING_ICON,
          title: "High Performance",
          description:
            "Built on Chrome's V8 JavaScript engine with non-blocking I/O for exceptional performance.",
        },
        {
          icon: Images.SVG_STRUCTURE_ICON,
          title: "Scalable Architecture",
          description:
            "Event-driven architecture perfect for data-intensive real-time applications.",
        },
        {
          icon: Images.SVG_GLOBAL_ICON,
          title: "Rich Ecosystem",
          description:
            "Access to npm's vast package registry with millions of reusable modules.",
        },
        {
          icon: Images.SVG_LAYER_ICON,
          title: "Full-Stack JavaScript",
          description:
            "Use JavaScript for both frontend and backend development with shared code.",
        },
      ],
    },
    techAdvantage: {
      title: "Perfect For Backend Services",
      description:
        "From APIs to real-time applications, Node.js provides the performance and scalability needed for modern backend development.",
      data: [
        "REST APIs & GraphQL Services",
        "Real-time Chat Applications",
        "Microservices Architecture",
        "IoT Data Processing",
        "Streaming Applications",
        "Command Line Tools",
      ],
      quickStart: [
        "# Initialize new project",
        "npm init -y",
        "# Create server file",
        "touch server.js",
        "# Run the server",
        "node server.js",
      ],
      viewDocPath: "https://nodejs.org/en/docs/",
    },
    footer: {
      title: "Ready to Build Backend Services?",
      description:
        "Join millions of developers building scalable server-side applications with Node.js.",
    },
  },
  mongodb: {
    homeSection: {
      sectionHeader: "🍃 NoSQL Database",
      title: "MongoDB",
      img: Images.SVG_MONGODB_ICON,
      description:
        "Create scalable and high-performance applications with MongoDB. Build modern apps using flexible document-based storage designed for speed and agility.",
      achievements: [
        {
          label: "Downloads/Month",
          count: "3B+",
        },
        {
          label: "GitHub Stars",
          count: "98k+",
        },
        {
          label: "Years Strong",
          count: "14+",
        },
        {
          label: "Foundation",
          count: "OpenJS",
        },
      ],
    },
    whychooseTech: {
      title: "Why Choose MongoDB?",
      description: "Discover why MongoDB is preferred for modern applications.",
      data: [
        {
          icon: Images.SVG_STRUCTURE_ICON,
          title: "Flexible Schema",
          description:
            "Store JSON-like documents with dynamic schemas for easy evolution.",
        },
        {
          icon: Images.SVG_LIGHTING_ICON,
          title: "High Performance",
          description:
            "Optimized for read/write operations and high throughput.",
        },
        {
          icon: Images.SVG_FLEXIBLE_ICON,
          title: "Scalable",
          description:
            "Horizontal scaling with sharding for large-scale applications.",
        },
        {
          icon: Images.SVG_GLOBAL_ICON,
          title: "Rich Ecosystem",
          description: "Integrated with many tools, drivers, and frameworks.",
        },
      ],
    },
    techAdvantage: {
      title: "Perfect For Backend Services",
      description:
        "From APIs to real-time applications, Node.js provides the performance and scalability needed for modern backend development.",
      data: [
        "REST APIs & GraphQL Services",
        "Real-time Chat Applications",
        "Microservices Architecture",
        "IoT Data Processing",
        "Streaming Applications",
        "Command Line Tools",
      ],
      quickStart: [
        "# Initialize new project",
        "npm init -y",
        "# Create server file",
        "touch server.js",
        "# Run the server",
        "node server.js",
      ],
      viewDocPath: "https://nodejs.org/en/docs/",
    },
    footer: {
      title: "Ready to Build Modern Databases?",
      description:
        "Join developers leveraging MongoDB for flexible, scalable, and high-performance data storage solutions.",
    },
  },
  graphql: {
    homeSection: {
      sectionHeader: "🕸️ Query Language",
      title: "GraphQL",
      img: Images.SVG_GRAPHQL_ICON,
      description:
        "Create flexible and efficient APIs with GraphQL. Build applications that fetch exactly the data they need, reducing over-fetching and improving performance.",
      achievements: [
        {
          label: "Downloads/Month",
          count: "3B+",
        },
        {
          label: "GitHub Stars",
          count: "98k+",
        },
        {
          label: "Years Strong",
          count: "14+",
        },
        {
          label: "Foundation",
          count: "OpenJS",
        },
      ],
    },
    whychooseTech: {
      title: "Why Choose GraphQL?",
      description:
        "Discover why GraphQL is ideal for flexible and efficient APIs.",
      data: [
        {
          icon: Images.SVG_FLEXIBLE_ICON,
          title: "Efficient Data Fetching",
          description:
            "Clients can request exactly what they need, nothing more, nothing less.",
        },
        {
          icon: Images.SVG_STRUCTURE_ICON,
          title: "Single Endpoint",
          description:
            "Simplifies API calls by exposing a single endpoint for all queries and mutations.",
        },
        {
          icon: Images.SVG_CODE_ICON,
          title: "Strongly Typed",
          description:
            "Schema defines types, enabling validation and better tooling support.",
        },
        {
          icon: Images.SVG_RAPID_ICON,
          title: "Rapid Development",
          description:
            "Easier frontend/backend collaboration and faster iteration.",
        },
      ],
    },
    techAdvantage: {
      title: "Perfect For API Development",
      description:
        "GraphQL enables efficient, flexible, and strongly typed APIs for modern applications.",
      data: [
        "Single Endpoint for APIs",
        "Efficient Data Fetching",
        "Strongly Typed Schema",
        "Real-time Subscriptions",
        "Rapid Frontend-Backend Iteration",
        "Improved Developer Experience",
      ],
      quickStart: [
        "# Install Apollo Server",
        "npm install apollo-server graphql",
        "# Create server file",
        "touch index.js",
        "# Run the server",
        "node index.js",
      ],
      viewDocPath: "https://graphql.org/learn/",
    },
    footer: {
      title: "Ready to Build Efficient APIs?",
      description:
        "Join developers using GraphQL to build flexible, strongly-typed, and efficient APIs for modern applications.",
    },
  },
  postgresql: {
    homeSection: {
      sectionHeader: "🕸️ Query Language",
      title: "Postgresql",
      img: Images.SVG_POSTGRESQL_ICON,
      description:
        "Create reliable and scalable databases with PostgreSQL. Build applications with advanced SQL features, strong ACID compliance, and enterprise-grade performance.",
      achievements: [
        {
          label: "Downloads/Month",
          count: "3B+",
        },
        {
          label: "GitHub Stars",
          count: "98k+",
        },
        {
          label: "Years Strong",
          count: "14+",
        },
        {
          label: "Foundation",
          count: "OpenJS",
        },
      ],
    },
    whychooseTech: {
      title: "Why Choose PostgreSQL?",
      description:
        "Discover why PostgreSQL is trusted for reliable and robust relational databases.",
      data: [
        {
          icon: Images.SVG_BADGE_WHITE_ICON,
          title: "ACID Compliance",
          description: "Ensures reliable transactions and data integrity.",
        },
        {
          icon: Images.SVG_LIGHTING_ICON,
          title: "Advanced Features",
          description: "Supports JSON, indexing, full-text search, and more.",
        },
        {
          icon: Images.SVG_FLEXIBLE_ICON,
          title: "Extensible",
          description: "Add custom functions, data types, and extensions.",
        },
        {
          icon: Images.SVG_GLOBAL_ICON,
          title: "Strong Community",
          description:
            "Well-maintained open-source ecosystem with excellent support.",
        },
      ],
    },
    techAdvantage: {
      title: "Perfect For Relational Databases",
      description:
        "PostgreSQL is a reliable, powerful, and extensible relational database for modern applications.",
      data: [
        "ACID-Compliant Transactions",
        "Advanced Querying Features",
        "JSON & JSONB Support",
        "Full-Text Search",
        "High Availability & Replication",
        "Extensible with Custom Functions",
      ],
      quickStart: [
        "# Install PostgreSQL",
        "brew install postgresql",
        "# Start PostgreSQL service",
        "brew services start postgresql",
        "# Create database",
        "createdb mydb",
        "# Connect to database",
        "psql mydb",
      ],
      viewDocPath: "https://www.postgresql.org/docs/",
    },
    footer: {
      title: "Ready to Build Reliable Databases?",
      description:
        "Join developers building robust and scalable applications with PostgreSQL’s powerful relational database features.",
    },
  },
};
export const TECHNOLOGIES_TABS: TechnologyTabsTypes[] = [
  {
    label: "React Native",
    to: `${PATH_TECHNOLOGY}/reactNative`,
    navigationType: "_blank",
    type: "reactNative",
  },
  {
    label: "React Js",
    to: `${PATH_TECHNOLOGY}/react`,
    navigationType: "_blank",
    type: "react",
  },
  {
    label: "Node Js",
    to: `${PATH_TECHNOLOGY}/node`,
    navigationType: "_blank",
    type: "node",
  },
  {
    label: "MongoDB",
    to: `${PATH_TECHNOLOGY}/mongodb`,
    navigationType: "_blank",
    type: "mongodb",
  },
  {
    label: "GraphQL",
    to: `${PATH_TECHNOLOGY}/graphql`,
    navigationType: "_blank",
    type: "graphql",
  },
  {
    label: "PostGreSql",
    to: `${PATH_TECHNOLOGY}/postgresql`,
    navigationType: "_blank",
    type: "postgresql",
  },
];

export const SERVICE_DEATIL_PAGE: ServiceDetailPageItemType = {
  web_development: {
    homeSection: {
      sectionHeader: "💻 Web Development Services",
      headingPart1: "Custom",
      headingPart2: "Web Solutions",
      description:
        "Build powerful, scalable websites and web applications that drive your business forward. From simple landing pages to complex enterprise solutions.",
      serviceAdvantage: [
        {
          title: "Responsive Design",
          icon: Images.SVG_GLOBAL_THEME,
        },
        {
          title: "Database Integration",
          icon: Images.SVG_LAYERS_THEME,
        },
        {
          title: "Mobile Optimization",
          icon: Images.SVG_MOBILE_APP_THEME,
        },
      ],
    },
    technologyWeUseSection: {
      title: "Technologies We Use",
      description:
        "Modern tools and frameworks for cutting-edge web development",
      data: [
        { title: "React", description: "Modern frontend framework" },
        { title: "Node.js", description: "Backend development" },
        { title: "TypeScript", description: "Type-safe development" },
        { title: "Next.js", description: "Full-stack React framework" },
        { title: "MongoDB", description: "NoSQL database solutions" },
        { title: "PostgreSQL", description: "Relational database" },
      ],
    },
    ourDevelopmentProcess: {
      title: "Our Development Process",
      description:
        "A proven methodology that ensures quality and timely delivery",
      data: [
        {
          step: 1,
          title: "Discovery",
          description: "Understanding your requirements and goals",
        },
        {
          step: 2,
          title: "Planning",
          description: "Architecture design and technology selection",
        },
        {
          step: 3,
          title: "Development",
          description: "Agile development with regular updates",
        },
        {
          step: 4,
          title: "Testing",
          description: "Quality assurance and performance testing",
        },
        {
          step: 5,
          title: "Deployment",
          description: "Launch and ongoing maintenance",
        },
      ],
    },
    portfolioSection: {
      headingPart1: "What We Build",
      description:
        "From concept to deployment, we create web solutions that deliver results",
      portfolio: PORTFOLIO,
    },
    callToActionSection: {
      title: "Ready to Build Your Website?",
      description:
        "Let's discuss your project requirements and create a solution that exceeds your expectations.",
    },
  },
  mobile_app_developemnt: {
    homeSection: {
      sectionHeader: "📱 Mobile App Development",
      headingPart1: "Native & ",
      headingPart2: "Cross-Platform Apps",
      description:
        "Create powerful mobile applications that engage users and drive business growth. From iOS and Android to cross-platform solutions.",
      serviceAdvantage: [
        { title: "Mobile First", icon: Images.SVG_MOBILE_APP_THEME },
        { title: "Tablet Ready", icon: Images.SVG_MOBILE_APP_THEME },
        { title: "Cross Device", icon: Images.SVG_MONITOR_THEME },
      ],
    },
    portfolioSection: {
      headingPart1: "Types of Apps We Build",
      description: "From simple utilities to complex enterprise applications",
      portfolio: PORTFOLIO,
    },
    techMultiplePlatform: {
      title: "One Codebase, Multiple Platforms",
      description:
        "Develop faster and more efficiently with shared business logic and UI components.",
      data: [
        {
          type: "Native Performance",
          title: "iOS",
          description:
            "Native iOS experience with platform-specific components and behaviors",
          icon: Images.SVG_MOBILE_DEVELOPMENT_ICON,
          to: "/ios",
        },
        {
          type: "Shared Logic",
          title: "React Native",
          description:
            "Single codebase powering both platforms with 90%+ code reuse",
          icon: Images.SVG_CODE_ICON,
          to: "/react-native",
        },
        {
          type: "Native Performance",
          title: "Android",
          description:
            "Native Android experience following Material Design principles",
          icon: Images.SVG_GLOBAL_ICON,
          to: "/android",
        },
      ],
    },
    feature: {
      title: "Advanced App Features",
      description: "Cutting-edge functionality to enhance user experience",
      data: [
        {
          title: "Native performance optimization",
          icon: Images.SVG_TICK_ICON,
        },
        { title: "Offline functionality", icon: Images.SVG_TICK_ICON },
        { title: "Push notifications", icon: Images.SVG_TICK_ICON },
        { title: "In-app purchases", icon: Images.SVG_TICK_ICON },
        { title: "Location-based services", icon: Images.SVG_TICK_ICON },
        { title: "Camera & media integration", icon: Images.SVG_TICK_ICON },
        { title: "Biometric authentication", icon: Images.SVG_TICK_ICON },
        { title: "Real-time synchronization", icon: Images.SVG_TICK_ICON },
      ],
    },
    ourDevelopmentProcess: {
      title: "From Idea to App Store",
      description:
        "Our streamlined process ensures your app launches successfully",
      data: [
        {
          step: 1,
          title: "Strategy",
          description: "Market research and app planning",
        },
        {
          step: 2,
          title: "Design",
          description: "UI/UX design and prototyping",
        },
        {
          step: 3,
          title: "Development",
          description: "Coding and feature implementation",
        },
        {
          step: 4,
          title: "Launch",
          description: "App store submission and marketing",
        },
      ],
    },
    callToActionSection: {
      title: "Ready to Launch Your Mobile App?",
      description:
        "Turn your app idea into reality with our expert mobile development team.",
    },
  },
  ui_ux: {
    homeSection: {
      sectionHeader: "🎨 UI/UX Design Services",
      headingPart1: "Design ",
      headingPart2: "That Converts",
      description:
        "Create exceptional user experiences that delight your customers and drive business results. From research to final design, we craft solutions that work.",
      serviceAdvantage: [
        { title: "User-Centered Design" },
        { title: "Data-Driven Decisions" },
        { title: "Conversion Optimization" },
      ],
    },
    portfolioSection: {
      headingPart1: "What We Build",
      description:
        "From concept to deployment, we create web solutions that deliver results",
      portfolio: PORTFOLIO,
    },
    ourDevelopmentProcess: {
      title: "Design Process",
      description:
        "From research to final design, our proven methodology delivers results",
      data: [
        {
          step: 1,
          title: "Research",
          description: "User research and competitive analysis",
        },
        {
          step: 2,
          title: "Define",
          description: "Problem definition and user personas",
        },
        {
          step: 3,
          title: "Ideate",
          description: "Brainstorming and concept development",
        },
        {
          step: 4,
          title: "Design",
          description: "Wireframes, prototypes, and visual design",
        },
        {
          step: 5,
          title: "Test",
          description: "Usability testing and iteration",
        },
      ],
    },
    feature: {
      title: "What We Design",
      description: "Comprehensive design solutions for all your digital needs",
      data: [
        { title: "Website Design", icon: Images.SVG_EYE_BLUE_ICON },
        { title: "Mobile App UI", icon: Images.SVG_EYE_BLUE_ICON },
        { title: "Dashboard Design", icon: Images.SVG_EYE_BLUE_ICON },
        { title: "E-commerce UX", icon: Images.SVG_EYE_BLUE_ICON },
        { title: "Landing Pages", icon: Images.SVG_EYE_BLUE_ICON },
        { title: "Design Systems", icon: Images.SVG_EYE_BLUE_ICON },
        { title: "Brand Identity", icon: Images.SVG_EYE_BLUE_ICON },
        { title: "Accessibility Design", icon: Images.SVG_EYE_BLUE_ICON },
      ],
    },
    technologyWeUseSection: {
      title: "Design Tools & Technologies",
      description: "Industry-leading tools for professional design workflows",
      data: [
        { title: "Figma" },
        { title: "Sketch" },
        { title: "Adobe XD" },
        { title: "Principle" },
        { title: "InVision" },
        { title: "Miro" },
      ],
    },
    highlightBlock: {
      title: "Why Good Design Matters",
      description: "The business impact of thoughtful design",
      data: [
        {
          count: "200%",
          title: "Increased Conversions",
          description:
            "Well-designed interfaces can increase conversion rates by up to 200%",
        },
        {
          count: "88%",
          title: "Better User Retention",
          description:
            "Good UX design improves user retention and reduces bounce rates",
        },
        {
          count: "100:1",
          title: "Higher Revenue",
          description:
            "Companies investing in UX see a return of $100 for every $1 invested",
        },
        {
          count: "70%",
          title: "Faster User Adoption",
          description:
            "Intuitive design accelerates learning curves and boosts adoption rates",
        },
      ],
    },
    callToActionSection: {
      title: "Ready to Transform Your User Experience?",
      description:
        "Let's create designs that not only look great but drive real business results",
    },
  },
  digital_marketing: {
    homeSection: {
      sectionHeader: "📢 Digital Marketing Services",
      headingPart1: "Grow Your ",
      headingPart2: "Digital Presence",
      description:
        "Strategic digital marketing that drives real results. From SEO and social media to email campaigns and paid advertising, we help your business thrive online.",
      serviceAdvantage: [
        { title: "Website Traffic" },
        { title: "Lead Generation" },
      ],
    },
    portfolioSection: {
      headingPart1: "Marketing Services",

      description:
        "Explore our range of marketing services designed to boost visibility, engagement, and conversions.",
      portfolio: [
        {
          icon: Images.SVG_MOBILE_DEVELOPMENT_ICON,
          title: "SEO Optimization",
          desc: "Improve your search engine rankings and organic visibility",
          data: [
            "Keyword research",
            "On-page optimization",
            "Technical SEO",
            "Content strategy",
          ],
        },
        {
          icon: Images.SVG_MOBILE_DEVELOPMENT_ICON,
          title: "Social Media Marketing",
          desc: "Build your brand presence across all social platforms",
          data: [
            "Content creation",
            "Community management",
            "Paid advertising",
            "Analytics tracking",
          ],
        },
        {
          icon: Images.SVG_MOBILE_DEVELOPMENT_ICON,
          title: "Email Marketing",
          desc: "Nurture leads and retain customers with targeted campaigns",
          data: [
            "Campaign design",
            "List segmentation",
            "Automation",
            "Performance tracking",
          ],
        },
      ],
    },
    ourDevelopmentProcess: {
      title: "Our Marketing Process",
      description: "Data-driven approach for consistent growth and ROI",
      data: [
        {
          step: 1,
          title: "Audit",
          description: "Comprehensive analysis of current marketing efforts",
        },
        {
          step: 2,
          title: "Strategy",
          description: "Custom marketing strategy based on your goals",
        },
        {
          step: 3,
          title: "Execute",
          description: "Launch campaigns across multiple channels",
        },
        {
          step: 4,
          title: "Optimize",
          description: "Continuous optimization based on performance data",
        },
      ],
    },
    highlightBlock: {
      title: "Proven Results",
      description:
        "Real metrics from our successful digital marketing campaigns",
      data: [
        {
          count: "150%",
          title: "Average Traffic Increase",
          description: "Within 6 months",
        },
        {
          count: "300%",
          title: "Lead Generation Growth",
          description: "Through optimized campaigns",
        },
        {
          count: "250%",
          title: "ROI Improvement",
          description: "On marketing spend",
        },
        {
          count: "75%",
          title: "Conversion Rate Boost",
          description: "With targeted strategies",
        },
      ],
    },
    feature: {
      title: "Marketing Tools & Platforms",
      description: "Professional tools for maximum marketing effectiveness",
      data: [
        { title: "Google Analytics", icon: Images.SVG_GRAPH_BLUE },
        { title: "Google Ads", icon: Images.SVG_GRAPH_BLUE },
        { title: "Facebook Business", icon: Images.SVG_GRAPH_BLUE },
        { title: "HubSpot", icon: Images.SVG_GRAPH_BLUE },
        { title: "Mailchimp", icon: Images.SVG_GRAPH_BLUE },
        { title: "SEMrush", icon: Images.SVG_GRAPH_BLUE },
        { title: "Ahrefs", icon: Images.SVG_GRAPH_BLUE },
        { title: "Hootsuite", icon: Images.SVG_GRAPH_BLUE },
      ],
    },
    expertise: {
      title: "Marketing Channels We Master",
      description: "Multi-channel approach for maximum reach and impact",
      data: [
        {
          title: "Search Engine Marketing",
          description: "Dominate search results with SEO and PPC campaigns",
          data: [
            "Google Ads",
            "Bing Ads",
            "Local SEO",
            "Technical optimization",
          ],
        },
        {
          title: "Content Marketing",
          description: "Engage your audience with valuable, relevant content",
          data: [
            "Blog writing",
            "Video content",
            "Infographics",
            "Content strategy",
          ],
        },
        {
          title: "Social Media Advertising",
          description: "Targeted campaigns across all major social platforms",
          data: [
            "Facebook Ads",
            "Instagram campaigns",
            "LinkedIn marketing",
            "TikTok advertising",
          ],
        },
      ],
    },
    callToActionSection: {
      title: "Ready to Accelerate Your Growth?",
      description:
        "Let's create a digital marketing strategy that drives real results for your business.",
    },
  },
};

export const TECHNOLOGY_WE_USE_SECTION: TechnologyWeUseSectionType = {
  title: "Technologies We Use",
  description:
    "We work with cutting-edge technologies to deliver robust, scalable, and future-ready solutions.",
  data: [
    { title: "React" },
    { title: "Node.js" },
    { title: "TypeScript" },
    { title: "GraphQl" },
    { title: "MongoDB" },
    { title: "PostgreSQL" },
  ],
};
